import Vue from "vue";
import config from "@/config";
import errorTags from "@/errorTags";
import router from "@/router";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    language: "mn",
    _loading: {
      login: false,
      logout: false,
      updatePassword: false,
      addPlayer1: false,
      getTAC1: false,
      addMember: false,
      getTAC: false,
      getPromo: false,
      wbDeposit: false,
      muDeposit: false,
      getMemberBankMode: false,
      getMemberBankLookup: false,
      getMemberBankList: false,
      addMemberBank: false,
      addMemberFavGame: false,
      deleteMemberFavGame: false,
      getMemberFavGame: false,
      addWithdrawTicket: false,
      memberTicketList: false,
      memberTransferList: false,
      dailyWinloseProvider: false,
      getMemberGameResult: false,
      memberTransfer: false,
      getMemberRebateWallet: false,
      getMemberRebateClaim: false,
      forgotPassword: false
    },
    refreshKey: 0,
    account: "",
    balance: 0,
    //new added
    provider: "",
    favGame: [],
    gameMenuSelected: "",
    generalMenuSelected: "",
    memberMode: [],
    memberBankMode: [],
    workingDate: "",
    pageSize: 10,
    tacExpiry: 0
  },
  mutations: {
    updateLanguage(state, payload) {
      i18n.locale = payload;
      state.language = payload;
    },
    update(state, payload) {
      state.account = payload.data;
    },
    delete(state) {
      state.account = "";
      state.balance = 0;      
      //new added
      state.provider = "";
      state.favGame = [];
      state.gameMenuSelected = "all";
      state.generalMenuSelected = "";
      state.memberMode = [];
      state.memberBankMode = [];
      state.workingDate = "";
      state.tacExpiry = 0;
    },
    loading(state, payload) {
      if ("action" in payload) {
        const action = payload.action;
        const status = payload.status;
        state._loading[action] = status;
      }
    },
    updateBalance(state, payload) {
      state.balance = payload.available_balance;
    },
    updateUsername(state, payload){
      state.account.nickname = payload
    },
    updateRefreshKey(state, payload) {
      state.refreshKey = payload;
    },
    updateProvider(state, payload) {
      state.provider = payload;
    },
    updateFavGame(state, payload) {
      state.favGame = payload
    },
    updateGameMenuSelected(state, payload) {
      state.gameMenuSelected = payload
    },
    updateGeneralMenuSelected(state, payload){
      state.generalMenuSelected = payload
    },
    updateMemberMode(state, payload){
      state.memberMode = payload
    },
    updateMemberBankMode(state, payload){
      state.memberBankMode = payload
    },
    updateWorkingDate(state, payload){
      state.workingDate = payload
    },
    updateTACExpiry(state, payload){
      state.tacExpiry = payload
    },
  },
  actions: {
    setLanguage(context, payload) {
      context.commit("updateLanguage", payload);
    },
    setRefreshKey(context, payload) {
      context.commit("updateRefreshKey", payload);
    },
    setProvider(context, payload) {
      context.commit("updateProvider", payload);
    },
    setFavGame(context, payload){
      context.commit("updateFavGame", payload)
    },
    setGameMenuSelected(context, payload){
      context.commit("updateGameMenuSelected", payload)
    },
    setGeneralMenuSelected(context, payload){
      context.commit("updateGeneralMenuSelected", payload)
    },
    setMemberMode(context, payload){
      context.commit("updateMemberMode", payload)
    },
    setMemberBankMode(context, payload){
      context.commit("updateMemberBankMode", payload)
    },
    setWorkingDate(context, payload){
      context.commit("updateWorkingDate", payload)
    },
    setTACExpiry(context, payload){
      context.commit("updateTACExpiry", payload)
    },
    login(context, user) {
      const url = config.memberLogin();
      const body = {
        login_id: user.login_id,
        password: user.password,
        login_source: user.login_source
      };
      const feedback = {
        success: false,
        status: errorTags.login.failed
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.login.usernameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.login.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.login == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }
        
        if (canRequest == true) {
          context.commit("loading", { action: "login", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "login", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  var sessionToken = null;
                  var data = null;
                  try {
                    sessionToken = successResponse.data.value.auth_token;
                    data = successResponse.data.value;
                    
                    if (sessionToken) {
                      context.commit("update", { data });
                      resolve(feedback);
                    } else {
                      context.commit("delete");
                      feedback.success = false;
                      feedback.status = errorTags.login.failed;
                      reject(feedback);
                    }
                  } catch (error) {
                    context.commit("delete");
                    feedback.success = false;
                    feedback.status = errorTags.login.failed;
                    reject(feedback);
                  }
                } else {
                  context.commit("delete");
                  router.push("/").catch(err=>{});
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "login", status: false });
              context.commit("delete");
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    logout(context) {
      const feedback = {
        success: true,
        status: errorTags.logout.succeed
      };
      return new Promise(resolve => {
        context.commit("delete");
        resolve(feedback);
      });
    },
    getBalance(context, user) {
      const url = config.getBalance();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getBalance.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.getBalance.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.getBalance.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getBalance == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getBalance", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getBalance", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  if(successResponse.body.status == "1"){
                    feedback.success = successResponse.body.status == "1"
                  }else{
                    feedback.success = false
                  }
                } else {
                  if(successResponse.body.status == 1){
                    feedback.success = successResponse.body.status == 1
                  }else{
                    feedback.success = false
                  }
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value[0];
                    context.commit("updateBalance", feedback.data);
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getBalance", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    updatePassword(context, user) {
      const url = config.updatePassword();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
        password: user.password,
        new_password: user.new_password        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.updatePassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.updatePassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("new_password" in user)) {
          feedback.status = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.updatePassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.updatePassword.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.new_password.length <= 0) {
          feedback.status = errorTags.updatePassword.newPasswordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.updatePassword == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "updatePassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "updatePassword", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "updatePassword", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    forgotPassword(context, user) {
      const url = config.forgotPassword();
      const body = {
        member_id: user.member_id,
        phone: user.phone,   
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.forgotPassword.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("member_id" in user)) {
          feedback.status = errorTags.forgotPassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("phone" in user)) {
          feedback.status = errorTags.forgotPassword.phoneRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.member_id.length <= 0) {
          feedback.status = errorTags.forgotPassword.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.phone.length <= 0) {
          feedback.status = errorTags.forgotPassword.phoneRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.forgotPassword == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "forgotPassword", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "forgotPassword", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "forgotPassword", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addPlayer1(context, user) {
      const url = config.addPlayer1();
      const body = {
        agent_id: user.agent_id,
        account_id: user.account_id,
        tac: user.tac_code        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.addPlayer1.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("agent_id" in user)) {
          feedback.status = errorTags.addPlayer1.agentIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("account_id" in user)) {
          feedback.status = errorTags.addPlayer1.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("tac_code" in user)) {
          feedback.status = errorTags.addPlayer1.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.agent_id.length <= 0) {
          feedback.status = errorTags.addPlayer1.agentIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.addPlayer1.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.tac_code.length <= 0) {
          feedback.status = errorTags.addPlayer1.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addPlayer1 == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "addPlayer1", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "addPlayer1", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "addPlayer1", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getTAC1(context, user) {
      const url = config.getTAC1();
      const body = {
        agent_id: user.agent_id,
        account_id: user.account_id,
        password: user.password,
        full_name: user.full_name,
        contact_phone: user.contact_phone,
        contact_email: user.contact_email
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getTAC1.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("agent_id" in user)) {
          feedback.status = errorTags.getTAC1.agentIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("account_id" in user)) {
          feedback.status = errorTags.getTAC1.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.getTAC1.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.agent_id.length <= 0) {
          feedback.status = errorTags.getTAC1.agentIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getTAC1.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.getTAC1.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getTAC1 == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getTAC1", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getTAC1", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getTAC1", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addPlayer1Direct(context, user) {
      const url = config.addPlayer1();
      const body = {
        agent_id: user.agent_id,
        account_id: user.account_id,
        password: user.password,
        full_name: user.full_name,
        contact_phone: user.contact_phone,
        contact_email: user.contact_email         
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.addPlayer1.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("agent_id" in user)) {
          feedback.status = errorTags.addPlayer1.agentIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("account_id" in user)) {
          feedback.status = errorTags.addPlayer1.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.addPlayer1.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.agent_id.length <= 0) {
          feedback.status = errorTags.addPlayer1.agentIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.addPlayer1.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.addPlayer1.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addPlayer1 == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "addPlayer1", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "addPlayer1", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "addPlayer1", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addMemberDirect(context, user) {
      const url = config.addMember();
      const body = {
        login_id: user.login_id,
        account_id: user.account_id,
        password: user.password,
        full_name: user.full_name,
        contact_phone: user.contact_phone,
        contact_email: user.contact_email      
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.addMember.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.addMember.loginIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("account_id" in user)) {
          feedback.status = errorTags.addMember.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.addMember.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.addMember.loginIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.addMember.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.addMember.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addMember == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "addMember", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "addMember", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "addMember", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addMember(context, user) {
      const url = config.addMember();
      const body = {
        login_id: user.login_id,
        account_id: user.account_id,
        tac: user.tac_code        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.addMember.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.addMember.loginIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("account_id" in user)) {
          feedback.status = errorTags.addMember.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("tac_code" in user)) {
          feedback.status = errorTags.addMember.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.addMember.loginIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.addMember.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.tac_code.length <= 0) {
          feedback.status = errorTags.addMember.tacCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addMember == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "addMember", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "addMember", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "addMember", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getTAC(context, user) {
      const url = config.getTAC();
      const body = {
        login_id: user.login_id,
        account_id: user.account_id,
        password: user.password,
        full_name: user.full_name,
        contact_phone: user.contact_phone,
        contact_email: user.contact_email
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getTAC.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.getTAC.loginIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("account_id" in user)) {
          feedback.status = errorTags.getTAC.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("password" in user)) {
          feedback.status = errorTags.getTAC.passwordRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.getTAC.loginIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_id.length <= 0) {
          feedback.status = errorTags.getTAC.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.password.length <= 0) {
          feedback.status = errorTags.getTAC.passwordRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getTAC == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getTAC", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getTAC", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getTAC", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberTransfer(context, user) {
      const url = config.memberTransfer();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
        account_from: user.account_from,
        account_to: user.account_to,
        transfer_type: user.transfer_type,
        transfer_amount: user.transfer_amount,
        remark: user.remark
      };
      const feedback = {
        success: false,
        status: errorTags.memberTransfer.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("account_from" in user)) {
          feedback.status = errorTags.memberTransfer.accountFromRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("account_to" in user)) {
          feedback.status = errorTags.memberTransfer.accountToRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("transfer_amount" in user)) {
          feedback.status = errorTags.memberTransfer.transferAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.account_from.length <= 0) {
          feedback.status = errorTags.memberTransfer.accountFromRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.account_to.length <= 0) {
          feedback.status = errorTags.memberTransfer.accountToRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.transfer_amount.length <= 0) {
          feedback.status = errorTags.memberTransfer.transferAmountRequired;
          reject(feedback);
          canRequest = false;
        }        

        if (this.state.user._loading.memberTransfer == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "memberTransfer", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "memberTransfer", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "memberTransfer", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    wbDeposit(context, user) {
      const url = config.manualDeposit();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
        amount: user.amount,
        bank_id: user.bank_id,
        bank_acc_no: user.bank_acc_no,
        bank_acc_holder: user.bank_acc_holder,
        ref_no: user.ref_no,
        attachment_path: user.attachment_path,
        deposit_date: user.deposit_date,
        deposit_method: user.deposit_method
      };
      const feedback = {
        success: false,
        status: errorTags.wbDeposit.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.wbDeposit.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("amount" in user)) {
          feedback.status = errorTags.wbDeposit.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_id" in user)) {
          feedback.status = errorTags.wbDeposit.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_acc_no" in user)) {
          feedback.status = errorTags.wbDeposit.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_acc_holder" in user)) {
          feedback.status = errorTags.wbDeposit.bankAccHolderRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.login_id.length <= 0) {
          feedback.status = errorTags.wbDeposit.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.amount.length <= 0) {
          feedback.status = errorTags.wbDeposit.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_id.length <= 0) {
          feedback.status = errorTags.wbDeposit.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_acc_no.length <= 0) {
          feedback.status = errorTags.wbDeposit.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_acc_holder.length <= 0) {
          feedback.status = errorTags.wbDeposit.bankAccHolderRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.wbDeposit == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "wbDeposit", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "wbDeposit", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "wbDeposit", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    muDeposit(context, user) {
      const url = config.manualDeposit();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
        amount: user.amount,
        attachment_path: user.attachment_path,
        promotion_id: user.promotion_id
      };
      const feedback = {
        success: false,
        status: errorTags.muDeposit.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.muDeposit.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("amount" in user)) {
          feedback.status = errorTags.muDeposit.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.login_id.length <= 0) {
          feedback.status = errorTags.muDeposit.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.amount.length <= 0) {
          feedback.status = errorTags.muDeposit.depositAmountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.muDeposit == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "muDeposit", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "muDeposit", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "muDeposit", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPromo(context, user) {
      const url = config.getPromo();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getPromo.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.getPromo.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.getPromo.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getPromo == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getPromo", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getPromo", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    if (
                      feedback.status == errorTags.session.expired ||
                      feedback.status == errorTags.session.invalidSession
                    ) {
                      context.commit("delete");
                      router.push("/").catch(err => {});
                    }
                    reject(feedback);
                  }
                } else {
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.status == errorTags.session.invalidSession
                  ) {
                    context.commit("delete");
                    router.push("/").catch(err => {});
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getPromo", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberRebateWallet(context, user) {
      const url = config.getMemberRebateWallet();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberRebateWallet.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.getMemberRebateWallet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.getMemberRebateWallet.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getMemberRebateWallet == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getMemberRebateWallet", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getMemberRebateWallet", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  if(successResponse.body.status == "1"){
                    feedback.success = successResponse.body.status == "1"
                  }else{
                    feedback.success = false
                  }
                } else {
                  if(successResponse.body.status == 1){
                    feedback.success = successResponse.body.status == 1
                  }else{
                    feedback.success = false
                  }
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getMemberRebateWallet", status: false });
              router.push("/").catch(err => {}); 
              feedback.status = errorResponse;
              reject(feedback);              
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberRebateClaim(context, user) {
      const url = config.getMemberRebateClaim();
      const body = {
        login_id: user.login_id,        
        auth_token: user.auth_token,
        amount: user.amount
      };
      const feedback = {
        success: false,
        status: errorTags.getMemberRebateClaim.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.getMemberRebateClaim.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("amount" in user)) {
          feedback.status = errorTags.getMemberRebateClaim.amountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.login_id.length <= 0) {
          feedback.status = errorTags.getMemberRebateClaim.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.amount.length <= 0) {
          feedback.status = errorTags.getMemberRebateClaim.amountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getMemberRebateClaim == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getMemberRebateClaim", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getMemberRebateClaim", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                // feedback.isFreeC = successResponse.body.isFreeC;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getMemberRebateClaim", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberBankMode(context, user) {
      const url = config.getMemberBankMode();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberBankMode.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.getMemberBankMode.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.getMemberBankMode.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getMemberBankMode == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getMemberBankMode", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getMemberBankMode", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  if(successResponse.body.status == "1"){
                    feedback.success = successResponse.body.status == "1"
                  }else{
                    feedback.success = false
                  }
                } else {
                  if(successResponse.body.status == 1){
                    feedback.success = successResponse.body.status == 1
                  }else{
                    feedback.success = false
                  }
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.dsvalue;
                    context.commit("updateMemberBankMode", feedback.data);
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getMemberBankMode", status: false });
              router.push("/").catch(err => {}); 
              feedback.status = errorResponse;
              reject(feedback);              
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberBankLookup(context, user) {
      const url = config.getMemberBankLookup();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberBankLookup.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.getMemberBankLookup.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.getMemberBankLookup.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getMemberBankLookup == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getMemberBankLookup", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getMemberBankLookup", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  if(successResponse.body.status == "1"){
                    feedback.success = successResponse.body.status == "1"
                  }else{
                    feedback.success = false
                  }
                } else {
                  if(successResponse.body.status == 1){
                    feedback.success = successResponse.body.status == 1
                  }else{
                    feedback.success = false
                  }
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getMemberBankLookup", status: false });
              router.push("/").catch(err => {}); 
              feedback.status = errorResponse;
              reject(feedback);              
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberBankList(context, user) {
      const url = config.getMemberBankList();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberBankList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.getMemberBankList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.getMemberBankList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getMemberBankList == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getMemberBankList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getMemberBankList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  if(successResponse.body.status == "1"){
                    feedback.success = successResponse.body.status == "1"
                  }else{
                    feedback.success = false
                  }
                } else {
                  if(successResponse.body.status == 1){
                    feedback.success = successResponse.body.status == 1
                  }else{
                    feedback.success = false
                  }
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getMemberBankList", status: false });
              router.push("/").catch(err => {}); 
              feedback.status = errorResponse;
              reject(feedback);              
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addMemberBank(context, user) {
      const url = config.addMemberBank();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
        bank_id: user.bank_id,
        bank_acc_holder: user.bank_acc_holder,
        bank_acc_no: user.bank_acc_no,
        is_default: user.is_default        
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.addMemberBank.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.addMemberBank.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_id" in user)) {
          feedback.status = errorTags.addMemberBank.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_acc_holder" in user)) {
          feedback.status = errorTags.addMemberBank.bankAccHolderRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("bank_acc_no" in user)) {
          feedback.status = errorTags.addMemberBank.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.addMemberBank.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_id.length <= 0) {
          feedback.status = errorTags.addMemberBank.bankIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_acc_holder.length <= 0) {
          feedback.status = errorTags.addMemberBank.bankAccHolderRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.bank_acc_no.length <= 0) {
          feedback.status = errorTags.addMemberBank.bankAccNoRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addMemberBank == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "addMemberBank", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "addMemberBank", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "addMemberBank", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addMemberFavGame(context, user) {
      const url = config.addMemberFavGame();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
        provider_code: user.provider_code,
        game_code: user.game_code,
        game_name: user.game_name,
        game_type: user.game_type,
        img_url: user.img_url       
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.addMemberFavGame.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.addMemberFavGame.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("provider_code" in user)) {
          feedback.status = errorTags.addMemberFavGame.providerCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("game_code" in user)) {
          feedback.status = errorTags.addMemberFavGame.gameCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("game_name" in user)) {
          feedback.status = errorTags.addMemberFavGame.gameNameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("game_type" in user)) {
          feedback.status = errorTags.addMemberFavGame.gameTypeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("img_url" in user)) {
          feedback.status = errorTags.addMemberFavGame.imgUrlRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.addMemberFavGame.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.provider_code.length <= 0) {
          feedback.status = errorTags.addMemberFavGame.providerCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.game_code.length <= 0) {
          feedback.status = errorTags.addMemberFavGame.gameCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.game_name.length <= 0) {
          feedback.status = errorTags.addMemberFavGame.gameNameRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.game_type.length <= 0) {
          feedback.status = errorTags.addMemberFavGame.gameTypeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.img_url.length <= 0) {
          feedback.status = errorTags.addMemberFavGame.imgUrlRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.addMemberFavGame == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "addMemberFavGame", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "addMemberFavGame", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "addMemberFavGame", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberFavGame(context, user) {
      const url = config.getMemberFavGame();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberFavGame.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.getMemberFavGame.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.getMemberFavGame.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.getMemberFavGame == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "getMemberFavGame", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "getMemberFavGame", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  if(successResponse.body.status == "1"){
                    feedback.success = successResponse.body.status == "1"
                  }else{
                    feedback.success = false
                  }
                } else {
                  if(successResponse.body.status == 1){
                    feedback.success = successResponse.body.status == 1
                  }else{
                    feedback.success = false
                  }
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    context.commit("updateFavGame", successResponse.body.value);
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "getMemberFavGame", status: false });
              router.push("/").catch(err => {}); 
              feedback.status = errorResponse;
              reject(feedback);              
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    deleteMemberFavGame(context, user) {
      const url = config.deleteMemberFavGame();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
        provider_code: user.provider_code,
        game_code: user.game_code      
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.deleteMemberFavGame.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.deleteMemberFavGame.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("provider_code" in user)) {
          feedback.status = errorTags.deleteMemberFavGame.providerCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("game_code" in user)) {
          feedback.status = errorTags.deleteMemberFavGame.gameCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.deleteMemberFavGame.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.provider_code.length <= 0) {
          feedback.status = errorTags.deleteMemberFavGame.providerCodeRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.game_code.length <= 0) {
          feedback.status = errorTags.deleteMemberFavGame.gameCodeRequired;
          reject(feedback);
          canRequest = false;
        }

        // if (this.state.user._loading.deleteMemberFavGame == true) {
        //   feedback.status = errorTags.request.processing;
        //   canRequest = false;
        // }

        if (canRequest == true) {
          // context.commit("loading", { action: "deleteMemberFavGame", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              // context.commit("loading", { action: "deleteMemberFavGame", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              // context.commit("loading", { action: "deleteMemberFavGame", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    addWithdrawTicket(context, user) {
      const url = config.addWithdrawTicket();
      const body = {
        login_id: user.login_id,        
        auth_token: user.auth_token,
        amount: user.amount
      };
      const feedback = {
        success: false,
        status: errorTags.addWithdrawTicket.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.addWithdrawTicket.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("amount" in user)) {
          feedback.status = errorTags.addWithdrawTicket.amountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (user.login_id.length <= 0) {
          feedback.status = errorTags.addWithdrawTicket.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.amount.length <= 0) {
          feedback.status = errorTags.addWithdrawTicket.amountRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.addWithdrawTicket == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "addWithdrawTicket", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "addWithdrawTicket", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                // feedback.isFreeC = successResponse.body.isFreeC;
                if (feedback.success == true) {
                  try {
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "addWithdrawTicket", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    dailyStatement(context, user) {
      const url = config.dailyStatement();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getStatement.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.getStatement.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getStatement == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getStatement", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getStatement", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getStatement", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberTicketList(context, user) {
      const url = config.memberTicketList();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.memberTicketList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.memberTicketList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.memberTicketList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.memberTicketList == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "memberTicketList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "memberTicketList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "memberTicketList", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    memberTransferList(context, user) {
      const url = config.memberTransferList();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
        page_size: user.page_size,
        page_number: user.page_number
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.memberTransferList.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.memberTransferList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.memberTransferList.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.memberTransferList == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "memberTransferList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "memberTransferList", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "memberTransferList", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    dailyWinloseProvider(context, user) {
      const url = config.dailyWinloseProvider();
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
        working_date: user.working_date
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.dailyWinloseProvider.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.dailyWinloseProvider.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("working_date" in user)) {
          feedback.status = errorTags.dailyWinloseProvider.workingDateRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.dailyWinloseProvider.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.working_date.length <= 0) {
          feedback.status = errorTags.dailyWinloseProvider.workingDateRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.dailyWinloseProvider == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "dailyWinloseProvider", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "dailyWinloseProvider", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "dailyWinloseProvider", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMemberGameResult(context, user) {
      const url = user.url
      const body = {
        login_id: user.login_id,
        auth_token: user.auth_token,
        working_date: user.working_date,
        page_size: user.page_size,
        page_number: user.page_number
      };
      const feedback = {
        data: [],
        success: false,
        status: errorTags.getMemberGameResult.failed
      };

      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!("login_id" in user)) {
          feedback.status = errorTags.getMemberGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }
        if (user.login_id.length <= 0) {
          feedback.status = errorTags.getMemberGameResult.accountIdRequired;
          reject(feedback);
          canRequest = false;
        }

        if (this.state.user._loading.getMemberGameResult == true) {
          feedback.status = errorTags.request.processing;
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", { action: "getMemberGameResult", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", { action: "getMemberGameResult", status: false });
              if (successResponse) {
                if (typeof successResponse.body.status == "string") {
                  feedback.success = successResponse.body.status == "1";
                } else {
                  feedback.success = successResponse.body.status == 1;
                }
                feedback.status = successResponse.body.statusdesc;
                if (feedback.success == true) {
                  try {
                    feedback.data = successResponse.body.value;
                    resolve(feedback);
                  } catch (error) {
                    switch (feedback.status) {
                      case errorTags.session.expired:
                      case errorTags.session.invalidToken:
                      case errorTags.session.invalidSession:
                      case errorTags.session.inactiveAccount:
                      case errorTags.session.sessionExpired:
                        context.commit("delete");
                        router.push("/").catch(err => {});
                        break;
                    }
                    reject(feedback);
                  }
                } else {
                  switch (feedback.status) {
                    case errorTags.session.expired:
                    case errorTags.session.invalidToken:
                    case errorTags.session.invalidSession:
                    case errorTags.session.inactiveAccount:
                    case errorTags.session.sessionExpired:
                      context.commit("delete");
                      router.push("/").catch(err => {});
                      break;
                  }
                  reject(feedback);
                }
              } else {
                // Response is empty...
                context.commit("delete");
                router.push("/").catch(err => {});
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", { action: "getMemberGameResult", status: false });
              context.commit("delete");
              router.push("/").catch(err => {});
              feedback.status = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
  }
};
